import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AlertClassColour, ConfigSystemParams, modalFormValues, msSize } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-user-modal-form-search',
  templateUrl: './user-modal-form-search.component.html',
  styleUrls: ['./user-modal-form-search.component.scss']
})

export class UserModalFormSearchComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Input() portalUsers: boolean | undefined;
  
  @Output() searchFormCancelled   : EventEmitter<boolean>=new EventEmitter<boolean>();
  @Output() searchFormHasBeenSaved: EventEmitter<void>   =new EventEmitter<void>   ();
  @Output() searchGridRowClick    : EventEmitter<number> =new EventEmitter<number> ();
  @Output() searchGridRowDblClick : EventEmitter<number> =new EventEmitter<number> ();

  @ViewChild('userModalFormSearch', { static: false }) searchFormModal! : TemplateRef<void>;
  @ViewChild('warningModalForm',    { static: false }) warningModalForm!: WarningModalFormComponent;
    
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  
  private initialStatus      : string="Add a new user or select a user from the table";
  private searchFormModalRef!: NgbModalRef;
  private selectedUserId     : number | undefined;
   
  public addNewUser          : boolean=false;
  public alertColourProgress : string=AlertClassColour.Green;
  public curUser             : SystemUserDTO;
  public formSubmitted       : boolean=false;
  public inviewCompanyID     : number | undefined;
  public inviewCompanyName   : string | undefined;
  public searchForm!         : UntypedFormGroup;
  public progressInformation : string=this.initialStatus;
  public submitButtonEnabled : boolean=false;
  public formTitle           : string="User Search";

  constructor(
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : UntypedFormBuilder,
    private lastPassKillerService: LastPassKillerService,
    private modalService         : NgbModal
  ) {
      this.curUser=this.authenticationService.currentUserObject();
  }
  
  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.addNewUser         =false;
      this.alertColourProgress=AlertClassColour.Green;
      this.formSubmitted      =false;
      this.inviewCompanyID    =undefined;
      this.inviewCompanyName  =undefined;
      this.progressInformation=this.initialStatus;
      this.selectedUserId     =undefined;
      this.submitButtonEnabled=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(inviewCompanyID: number, inviewCompanyName: string): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      
      if (inviewCompanyID==undefined || <number>inviewCompanyID<=0)
        throw new Error("UserModalFormSearchComponent..Inview Company cannot be determined");

      this.inviewCompanyID  =inviewCompanyID;
      this.inviewCompanyName=inviewCompanyName;

      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.searchFormModalRef=this.modalService.open(this.searchFormModal, { backdrop: this.modalBackGround,
                                                                             centered: true,
                                                                             keyboard: false,
                                                                             size    : msSize.ExtraLarge });
    }
    catch(e) {
      this.searchFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region searchForm
  
  get formOfSearch() {
    return this.searchForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.searchForm);

       this.searchForm=this.formBuilder.group({ });
      
      this.addFormFields(this.searchForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.searchForm) {
        this.addFormControl(formGroup, "newUser", false, []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.searchForm) {
        
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public searchFormSubmit() {
    try {
      this.formSubmitted=true;
      
      if (this.searchForm.valid) {
        if (!this.addNewUser && (this.selectedUserId==undefined || this.selectedUserId<0)) {

          this.warningModalForm.openForm("Select User", "within the data grid");

        } else {
          this.searchFormHasBeenSaved.emit();
          this.searchFormModalRef.close();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public searchFormCancel() {
    try {
      this.searchFormCancelled.emit();
      this.searchFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public newUserClick() {
    try {
      this.addNewUser=!this.addNewUser;

      if (this.addNewUser) {
        this.selectedUserId=modalFormValues.createNewUserId;

        this.searchGridRowClick.emit(this.selectedUserId);
        this.searchFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridRowClick(rowId: number){
    try {
      this.selectedUserId=rowId;

      this.searchGridRowClick.emit(this.selectedUserId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridRowDblClick(rowId: number){
    try {
      this.selectedUserId=rowId;
      
      this.searchGridRowDblClick.emit(this.selectedUserId);
      this.searchFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
}
